var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useRef, useState, } from 'react';
export const useCall = (callback, deps, defaultValue) => {
    const callbackRef = useRef(callback);
    const [state, setState] = useState({
        value: defaultValue !== null && defaultValue !== void 0 ? defaultValue : null,
        loading: false,
        error: null,
    });
    useEffect(() => {
        callbackRef.current = callback;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deps]);
    const handleCall = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setState(state => (Object.assign(Object.assign({}, state), { loading: true, error: null })));
        try {
            const result = yield callbackRef.current();
            setState({ loading: false, value: result, error: null });
            return result;
        }
        catch (error) {
            setState(state => (Object.assign(Object.assign({}, state), { loading: false, error })));
            return null;
        }
    }), []);
    return [state.value, handleCall, state.loading, state.error];
};
